// responseTimestamp - overrides the current timestamp for response
var savedResponseThisTrial = false;

function saveTrial(x, extra, responseTimestamp) //local variable, dies within function; saves each trial
{
  savedResponseThisTrial = true;
  if(typeof x == "string"){
    x = x.trim();
  }

  var currentTrialType = columnForTrial('responseType', window.trialRow);
  // if(currentTrialType == "box" || currentTrialType == "comment"){
  //   x = x.trim();
  //   x = x.replace(/\n/g, "\\n");
  // }

  console.log('responseTimestamp', responseTimestamp, performance.now(), timeInMs);

  const responseTime = responseTimestamp ? responseTimestamp : performance.now();
  var response = {
      "trialRow" : window.trialRow,
      "response": x,
      "timestamp": responseTime,
      "correct": false
  };

  window.saveAllTrialResponse(x, Math.round(responseTime - timeInMs));

  if (listArrays[allColumns.indexOf('type')][trialRow]=="test" && feedbackScreen == 0) //only for test trials and no feedback screens
  {
  tempRT = Math.round(responseTime - timeInMs);
  if (RTkeys_trial!='') {
    if(x.indexOf('timeout') > -1){
      RTkeys_trial = RTkeys_trial + ';' + tempRT;
    }
    RTkeys.push(RTkeys_trial);
    response.RTkeys_trial = RTkeys_trial;
  } else {
    RTkeys.push('');
  }

  window.RTs.push(tempRT);
  response.RT = tempRT;
  if(window.columnForTrial('presTime', trialRow)!="na"){
    window.recordIntrerruptedPresTime();
    window.presTime_ms.push(window.presTime_actual_temp);
    window.presTime_f.push(window.tempPresTimeFrames.join(';'));
    window.presTime_fDuration.push(window.meanFloats(window.tempPresTimeMeans).toFixed(2));
    window.tempPresTimeMeans = [];
    window.tempPresTimeDeviations = [];
    window.tempPresTimeLast = [];
    window.tempPresTimeFrames = [];
  }
  else{
    window.presTime_ms.push("na");
    window.presTime_f.push("na");
    window.presTime_fDuration.push("na");
  }

  if(columnForTrial('ITI', trialRow)!="na"){
    window.ITI_ms.push(window.realITI_temp);
  }
  else{
    window.ITI_ms.push("na");
  }

  saveActualStimOrder();

  console.log('ISI temp', window.realISI_temp);

  if(columnForTrial('ISI', trialRow)!="na"){
    // window.ISI_ms.push(window.realISI_temp + (' D:' + window.tempISIDeviations) + (' S:' + window.tempISILast));
    window.ISI_ms.push(window.realISI_temp);
    window.ISI_f.push(window.tempISIFrames.join(';'));
    const currentfDuration = window.meanFloats(window.tempISIMeans).toFixed(2);
    if(!isNaN(currentfDuration)){
      window.ISI_fDuration.push(currentfDuration);
    }
    else{
      window.ISI_fDuration.push("na");
    }
    window.tempISIMeans = [];
    window.tempISIDeviations = [];
    window.tempISILast = [];
    window.tempISIFrames = [];
  }
  else{
    window.ISI_ms.push("na");
    window.ISI_f.push("na");
    window.ISI_fDuration.push("na");
  }

  tempTimestamp = Math.round(responseTime - startTime);
  timestamps.push(tempTimestamp);
  response.tempTimestamp = tempTimestamp;

  responses.push(x); // also saves errors in CFPT
  window.responseTextValues.push(window.currentResponseText);
  console.log(tempRT);
  console.log(responses);
  var currentRowNo = computeRowNo(window.trialRow);
  
  pushRowNo(window.rowNo, currentRowNo);

  response.correct = saveCorrect(x, tempRT);

  for (var iCol = 0; iCol < allColumns.length; iCol++)
  {
    saveArrays[iCol].push(listArrays[iCol][trialRow]);
  }
  for (var iCol = 0; iCol < csvNewColumns.length; iCol++)
  {
    saveUnusedArrays[iCol].push(listUnusedArrays[iCol][trialRow]);
  }

  //save response in localstorage
  try {
    storeTrial(response, window.rowNo[window.rowNo.length - 1]);
  } catch (e) {
    Bugsnag && Bugsnag.notify(e);
  }

  window.stimPos_actual.push(window.stimPosList);

  if(window.responseCodes.length < window.responses.length){
    window.responseCodes.push("na");
    window.allResponseCodes.push("na");
    window.rowResponseCodes[window.trialRow] = "na";
  }

  window.saveTallies();
  window.saveScores(trialRow, '');
  window.responseRowsActual.push("na");
 }

  if (listArrays[allColumns.indexOf('type')][trialRow]=="practice" && feedbackScreen == 0) //only for practice trials
  {
    response.correct = savePractice(x);
    window.cleanTemporaryTimingVars();
  }

  if (window.multiplayer && isMultiplayerTrial(window.trialRow)) {
    if (extra) {
      response.extra = extra;
    }
    window.multiplayer.response(window.trialRow, response);
  }
}

function saveTrialCFPT(x,finalOrder) //local variable, dies within function; saves each trial
{
  if (listArrays[allColumns.indexOf('type')][trialRow]=="test" && feedbackScreen == 0) //only for test trials and no feedback screens
  {
  tempRT = Math.round(performance.now()-timeInMs);
  RTs.push(tempRT);
  window.allRTs.push(tempRT);
  window.rowRTs[window.trialRow] = tempRT;
  window.presTime_ms.push(window.presTime_actual_temp);
  tempTimestamp = Math.round(performance.now() - startTime);
  window.timestamps.push(tempTimestamp);
  console.log(tempRT);
  console.log(responses);
  window.allResponses.push(finalOrder);
  window.responses.push(finalOrder); // record final order
  var currentRowNo = window.trialRow + 2;
  pushRowNo(window.rowNo, currentRowNo);
  saveActualStimOrder();
  window.correct.push(x);//record total errors for trial

  for (var iCol = 0; iCol < allColumns.length; iCol++)
  {
    saveArrays[iCol].push(listArrays[iCol][trialRow]);
  }
  for (var iCol = 0; iCol < csvNewColumns.length; iCol++)
  {
    saveUnusedArrays[iCol].push(listUnusedArrays[iCol][trialRow]);
  }
 }

}

function saveCorrect(response, RT){
  const correctValue = getCorrectValue(response, RT)
  var isCorrect = correctValue == "1";

  window.correct.push(correctValue);

  if(columnForTrial('select', window.trialRow) != 'na') {
    window.correctSelect.push(correctValue);
    window.hasCorrectSelect = true;
  }

  //currently when a trial timesout  it sets the response as "999", should probably change it to push to the timeout var
  if(response == "999" || (response + '').indexOf('timeout')>=0){
    timeout.push(1);
  }
  else{
    timeout.push(0);
  }

  return isCorrect;
}

function savePractice(response){
  const keyValue = window.columnForTrial('key', window.trialRow).toLowerCase();
  const correctValue = getCorrectValue(response, "na")
  var isCorrect = correctValue == "1";

  window.correctPractice.push(correctValue);

  if(response == "999" || (response + '').indexOf('timeout')>=0){
    timeoutPractice.push(1);
  }
  else {
    timeoutPractice.push(0);
  }

  return isCorrect;
}
